a<template>
  <splash></splash>
  <div class="container mt-4" dir="rtl">


    <sidebar></sidebar>
    <div class="card-panel-main col-lg-9 mb-5" style="transform: translateX(-19vw);  ">
      <center class="col-lg-12  " style="transform: translateY(2vw); margin-bottom: 2vw; ">
        <div class="bg-white text-dark fw-bolder d-flex flex-row align-items-center justify-content-between p-2 shadow" style="border-radius: 1vw; width: 56vw; transform: translateX(0.7vw); cursor: text" title="سامانه جامع و یکپارچه بهفام">
          <div class="d-flex mt-3"><router-link class="text-decoration-none text-black " to="/settings">تنظیمات</router-link> <p class="mx-2">/</p> <p>درباره بهفام</p></div> <img src="../../assets/img/android-chrome-192x192.png" class="img-fluid" style="height: 3vw;" alt="">
        </div>

      </center>
      <div class="row align-items-center justify-content-center" style="transform: translateY(1vw)">
        <div class="card mb-5  bg-white shadow" style="width: 56vw; transform: translateX(0.5vw)">
          <p class="text-end fw-500 p-3">
            شرکت آسان رای اندیش (آرا) با افتخار اعلام می‌کند که در سال ۱۴۰۲ با همکاری و همیاری تیمی مجرب و متخصص،
            سامانه بهفام را به منظور یکپارچگی سیستم‌های مدیریت در راستای افزایش بهره وری کسب و کارها طراحی و توسعه
            داده است. این سامانه با بهره‌گیری از جدیدترین فناوری‌ها و رویکردهای مدیریتی، به نحوی طراحی شده است که نظام
            مدیریت فرآیند را به عنوان پایه‌ی خود قرار داده و سایر نظام‌های مدیریتی را به آن متصل می‌نماید. این سامانه، با توجه
            ویژه به ایجاد یکپارچگی بین نظام‌های مدیریتی، به سازمان‌ها کمک می‌کند تا از این ظرفیت برای ایجاد ارزش افزوده
            بیشتر در سازمان خود بهره‌مند شوند.
          </p>
          <p class="text-end fw-500 p-3">
            در سامانه بهفام، امکان تعریف و مدیریت مستندات فرآیند، مدلسازی، بهینه‌سازی و ... فراهم شده است. این سامانه
            نظام‌هایی نظیر مدیریت ذی نفعان مبتنی بر فرآیند، مدیریت استراتژیک با در نظر گرفتن قابلیت‌های مورد انتظار فرآیند،
            نظام مدیریت عملکرد جامع با در نظر گرفتن شاخص‌های عملکردی و نتیجه‌ای فرآیندها و ... را در خود جای داده
            است.
          </p>
          <p class="text-end fw-500 p-3">
            با استفاده از سامانه بهفام، سازمان‌ها قادر خواهند بود فرآیندهای خود را به صورت جامع مدیریت کرده و از قابلیت‌های
            پیشرفته این سامانه برای بهبود عملکرد و دستیابی به اهداف استراتژیک خود استفاده نمایند. این سامانه، با بهره‌گیری از
            ابزارهای پیشرفته، زمینه‌ساز تحقق مدیریت هوشمند و کارآمد در سازمان‌ها می‌باشد.
          </p>
          <hr>
          <h4 style="font-size: 1.5vw !important" class="mt-3">
            منابع مورد نیاز یا حداقل سیستم
          </h4>
          <div class="text-end mb-3">

            <br>
             پردازنده: 4 هسته ای  با فرکانس 2.5 گیگاهرتز
            <br>

            رم : 8 گیگ
            <br>

            هارد: ssd  (متناسب با نیاز)
            <br>

            شبکه : 1 گیگابیت بر ثانیه(در صورت استفاده در سرور یا هاست)
            <br>

            سیستم پیشنهادی (پرفورمنس بهتر)
            <br>

            Cpu: 8 یا 16 هسته ای با فرکانس بالای 3.4 گیگاهرتز
            <br>

            رم : 16 یا 32 گیگ
            <br>

            هارد: nvme (متناسب با نیاز)
            <br>

            شبکه : 1 گیگابیت بر ثانیه(در صورت استفاده در سرور یا هاست)
          </div>
        </div>


  </div>
  </div>
  </div>
</template>
<script >
import Sidebar from "@/components/Sidebar/Sidebar.vue";
import Splash from "@/components/Splash/Splash.vue";
import Settings from "@/components/Docs/Settings.vue";
import Calendar from "@/components/Docs/Calendar.vue";
import ResetPasswordIcon from "@/components/Icons/ResetPasswordIcon.vue";
import {useToast} from "vue-toastification";
import SettingsIcon from "@/components/Icons/SettingsIcon.vue";
import EyeOn from "@/components/Docs/EyeOn.vue";
import EyeOff from "@/components/Docs/EyeOff.vue";
const toast = useToast();

export  default {
  components: {EyeOff, EyeOn, SettingsIcon, ResetPasswordIcon, Calendar, Settings, Splash, Sidebar},
  data(){
    return{

    }
  },
  methods:{

  }

}
</script>
<style scoped>

p,label,small,a,div{
  font-size: 1vw;
}


input{
  border-color: #3c76f2;
}


</style>